/**
 * Safely retrieves the menhirUrl from weezConfig.
 * Returns null if temporary or menhirUrl is undefined.
 * @returns {string|null} The menhirUrl or null if not configured
 */
export function getMenhirUrl() {
    return window.weezConfig?.temporary?.menhirUrl ?? null;
}
